import React, { useEffect, useState } from 'react'
import CommonButton from '../Common/Button'
import { FormGroup, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap'
import FlexCol from '../Common/FlexCol'
import { Flex } from 'antd'
import DateSelect from '../Common/DateSelector'
import FormInput from '../Common/FormInput'
import TextArea from '../Common/TextArea'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import API, { action } from '../../Api'
import DropdownButton from '../Common/DropdownButton'
import { notification } from 'antd';
import dayjs from 'dayjs'
import { IoMdClose } from 'react-icons/io'

function AddPregnancy({ isOpen, toggle, selectedData }) {
    const [selectedid, setSelectedid] = useState('');
    const [loading, setLoading] = useState(false); 

   
    const id = localStorage.getItem('userid');
    const validationSchema = Yup.object({
        inseminationType: Yup.string().required('Insemination Type is required'),
        inseminationDate: Yup.date().required('Insemination Date is required'),
        cattleId: Yup.string().required('Cattle ID is required'),
        // description1: Yup.string().required('Description is required'),
        confirmedDate: Yup.date().required('Confirmed Date is required'),
        expectedDelivery: Yup.date().required('Expected Delivery Date is required'),
        // description2: Yup.string().required('Description is required'),
        serverity :  Yup.string().required('serverity is required'),
    })

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
          
            inseminationDate: '',
            cattleId: '',
            description1: '',
            confirmedDate: '',
            expectedDelivery: '',
            description2: '',
            serverity :'normal',
            // insemination_id :selectedid,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {  // Make onSubmit async
            // Handle form submission
            console.log('Form submitted with values:', values);
            setLoading(true);
            try {
                // Perform the async action here
              const result =  await action(API.MARK_PREGNANCY, {
                    cattle_id: values.cattleId,
                    insemination_id: selectedid,
                    confirmation_date :values.confirmedDate,
                    expected_delivery_date : values.expectedDelivery,
                    serverity : values.serverity,
                    pregnancy_notes : values.description2,
                    created_by : id
                });
                notification.success({ message: result?.response?.message, placement: "top", });
                // Reset the form and close the offcanvas after submission
                formik.resetForm();
                toggle();  // Assuming `toggle` is defined to close the offcanvas
            } catch (error) {
                notification.error({ message: error.response?.data?.response?.message, placement: "top", });
                // console.error(id ? 'Error updating role:' : 'Error creating role:', error);
            } finally {
                setLoading(false); // Stop loading
            }
        }
    });

    useEffect(() => {
        if (selectedData && selectedData.length > 0) {
            formik.setFieldValue("inseminationType", selectedData[0]?.InseminationType);
            formik.setFieldValue("inseminationDate", selectedData[0]?.InseminationDate);
            formik.setFieldValue("cattleId", selectedData[0]?.CattleID);
            formik.setFieldValue("description1", selectedData[0]?.description);
        
            
            console.log(selectedData[0]?.ID,"LLLK");
            setSelectedid(selectedData[0]?.ID);
        }
    }, [selectedData]);

console.log(selectedData,"hhh");

    // Clear expected delivery date when confirmation date changes
    useEffect(() => {
        if (formik.values.confirmedDate) {
            formik.setFieldValue("expectedDelivery", "");
        }
    }, [formik.values.confirmedDate]);

const toggle1 =()=>{
    formik.resetForm();
    toggle()
}
const option = [{label:"Normal",value:"normal"},{label:"Need care",value:"need_care"},{label:"Critical",value:"critical"}]
    return (
        <Offcanvas isOpen={isOpen} toggle={toggle1} direction="end" className="w-full md:!w-[320px] 2xl:!w-[480px]  max-h-full overflow-y-auto"   >
            
                     <button
                                      type="button"
                                      onClick={toggle1}
                                      aria-label="Close"
                                      style={{
                                          position: 'absolute',
                                          top: 12,
                                          right: 12,
                                          zIndex: 1001,
                                          background: 'transparent',
                                          border: 'none',
                                          cursor: 'pointer',
                                          padding: 2,
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                      }}
                                  >
                                      <IoMdClose size={18} color="#333" />
                                  </button>
            <FlexCol className={"p-4"} >

                <OffcanvasHeader>
                    <div>
                        <div className="text-[16px] font-semibold 2xl:text-2xl text-[#09090B] leading-[21.6px] break-words font-plus-jakarta-sans">
                            Record Pregnancy
                        </div>
                        <div className="text-[10px] 2xl:text-sm text-[#726C6C] font-plus-jakarta-sans">
                            Enter Pregnancy Information
                        </div>
                    </div>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <form onSubmit={formik.handleSubmit}>
                        <FormGroup>
                            <FlexCol className="" gap={20}>
                                <Flex className="grid grid-cols-1 gap-[30px] items-center">
                                    {/* Insemination Type */}
                                    <FormInput
                                        title="Insemination Type"
                                        placeholder="Enter Insemination Type"
                                        value={formik.values.inseminationType}
                                        change={(e) => formik.setFieldValue("inseminationType", e)}
                                      
                                        error={formik.touched.inseminationType && formik.errors.inseminationType}
                                        disabled={true}
                                        required= {true}
                                    />

                                    {/* Insemination Date */}
                                    <FormInput
                                        title="Insemination Date"
                                        placeholder="Choose Insemination Date"
                                        value={formik.values.inseminationDate}
                                        change={(e) => formik.setFieldValue("inseminationDate", e)}
                                       
                                        error={formik.touched.inseminationDate && formik.errors.inseminationDate}
                                        disabled={true}
                                        required= {true}
                                    />

                                    {/* Cattle ID */}
                                    <FormInput
                                        title="Cattle"
                                        placeholder="Enter Cattle Id"
                                        value={formik.values.cattleId}
                                        change={(e) => formik.setFieldValue("cattleId", e)}
                                        
                                        error={formik.touched.cattleId && formik.errors.cattleId}
                                        disabled={true}
                                        required= {true}
                                    />

                                    {/* Description 1 */}
                                    {formik.values.description1 &&(
                                    <TextArea
                                        title="Description"
                                        placeholder="Add Description"
                                        value={formik.values.description1}
                                        change={(e) => formik.setFieldValue("description1", e)}
                                        disabled={true}
                                        // error={formik.touched.description1 && formik.errors.description1}
                                    />
                                )}

                                    {/* Confirmed Date */}
                                    <DateSelect
                                        title="Confirmed Date"
                                        placeholder="Choose Confirmed Date"
                                        value={formik.values.confirmedDate}
                                        change={(e) => formik.setFieldValue("confirmedDate", e)}
                                        disabledFutureDate={true}
                                        error={formik.touched.confirmedDate && formik.errors.confirmedDate}
                                        required= {true}
                                    />

                                    {/* Expected Delivery */}
                                    <DateSelect
                                        title="Expected Delivery"
                                        placeholder="Choose Expected Delivery Date"
                                        value={formik.values.expectedDelivery}
                                        disableBeforeDate={formik.values.confirmedDate ? new Date(new Date(formik.values.confirmedDate).getTime() + 273 * 24 * 60 * 60 * 1000) : null}
                                        defaultPickerValue={formik.values.confirmedDate ? dayjs(new Date(formik.values.confirmedDate).getTime() + 273 * 24 * 60 * 60 * 1000) : null}
                                        change={(e) => formik.setFieldValue("expectedDelivery", e)}
                                        required= {true}
                                        error={formik.touched.expectedDelivery && formik.errors.expectedDelivery}
                                        disabled={!formik.values.confirmedDate}
                                    />
                                    <DropdownButton
                                      title="Severity"
                                      placeholder=""
                                      options={option}
                                      value={formik.values.serverity}
                                      change={(e) => formik.setFieldValue("serverity", e)}
                                      error={formik.touched.serverity && formik.errors.serverity}
                                      required= {true}
                                      SelectName="Select Severity"
                                    />
                                    {/* Description 2 */}
                                    <TextArea
                                        title="Description"
                                        placeholder="Add Description"
                                        value={formik.values.description2}
                                        change={(e) => formik.setFieldValue("description2", e)}
                                        // required= {true}
                                        // error={formik.touched.description2 && formik.errors.description2}
                                    />
                                </Flex>
                            </FlexCol>
                        </FormGroup>
                        <div className=" flex justify-between mt-8 ">
                            <CommonButton
                                style={{ fontSize: "12px", backgroundColor: "none", color: "#726C6C", border: "1px #CCCBCB solid ", marginRight: "8px" }}
                                onClick={toggle1}
                                outline
                                title='Discard'
                                disabled={loading}
                            />



                            <CommonButton title='Confirm Pregnancy' style={{ fontSize: "12px" }}  disabled={loading || formik.isSubmitting}/>


                        </div>
                    </form>
                </OffcanvasBody>

            </FlexCol>
        </Offcanvas>
    )
}

export default AddPregnancy